"use client";
import { getTranslation } from "@/i18n/get-translation";

import Facebook from "@/icons/facebook-dark.svg";
import Linkedin from "@/icons/linkedin-dark.svg";
import Instagram from "@/icons/instagram-dark.svg";
import FreshsalesContactForm from "@components/freshsales-contact-form/freshsales-contact-form";

interface IContactForm {
  locale: string;
}

export default function ContactForm({ locale }: IContactForm) {
  const t = getTranslation(locale, "contactUs.contactForm");

  return (
    <section className="flex justify-center items-center lg:flex-row flex-col lg:py-24 py-16 lg:my-20 my-12 bg-primary-500 relative">
      <div className="bg-(image:--circle-gradient) h-[14rem] w-[14rem] rounded-full rotate-45 absolute top-0 left-0 -translate-x-1/4 -translate-y-1/4 md:hidden block"></div>
      <div className="mx-auto xl:px-48 lg:px-20 px-7 flex lg:gap-24 lg:items-center items-start lg:flex-row flex-col w-full">
        {/* Contact content area */}
        <div className="flex flex-col justify-start items-stretch lg:flex-[1_1_40%] w-full flex-[1_1_100%] lg:pb-0 pb-6">
          <h2 className="leading-[1.15] font-medium mb-4 xl:text-[3rem] lg:text-[2.5rem] md:text-[2.2rem] text-[1.88rem] text-primary-800">
            {t("heading")}
          </h2>
          <p className="xl:text-xl lg:text-lg text-base font-light   text-primary-800 mb-8">
            {t("description")} <br className="lg:inline-block hidden" />{" "}
          </p>
          <h3 className="leading-[1.15] font-medium mb-3 xl:text-[2.1rem] lg:text-[1.7rem] text-[1.35rem] text-primary-800">
            {t("followUs")}
          </h3>
          <nav className="flex gap-3 text-lg">
            <a
              href="https://www.facebook.com/medlucyofficial"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on Facebook"
              className="w-10 h-10 text-primary-800 flex items-center justify-center leading-[0] bg-white bg-opacity-60  rounded-full"
            >
              <Facebook />
            </a>
            <a
              href="https://www.instagram.com/medlucyofficial/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on Instagram"
              className="w-10 h-10 text-primary-800 flex items-center justify-center leading-[0] bg-white bg-opacity-60 rounded-full"
            >
              <Instagram />
            </a>
            <a
              href="https://www.linkedin.com/company/medlucy/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on LinkedIn"
              className="w-10 h-10 text-primary-800 flex items-center justify-center leading-[0] bg-white bg-opacity-60 rounded-full"
            >
              <Linkedin />
            </a>
          </nav>
        </div>
        {/* Contact Form area */}
        <div className="flex justify-start items-start lg:flex-[0_0_50%] w-full flex-[1_1_100%]">
          <div className="flex-auto -mx-2">
            <div className="">
              <FreshsalesContactForm locale={locale} />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-(image:--circle-gradient) h-[14rem] w-[14rem] rounded-full -rotate-45  absolute top-[calc(100%-90px)] right-0 -translate-y-1/4 md:hidden block"></div>
    </section>
  );
}
